//
//
//
//
//
//
//
//
//
//
//

export default {
    id: 39,
    version: '3.8.20',
    date: '2024-05-23',
    notify: true,
}
